module.exports = __webpack_public_path__ + "static/img/client1.b6c41c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/clients/client1.jpg
// module id = 74
// module chunks = 1